import { MHTTPCL, JSON_STRING } from "../../../services/http/http-client";
import { MODIFICATION_URL,SETTINGS_URL } from "../../../services/common-urls";
import { LABEL_URL } from "../../accounting/services/costs.service";

export const PromotionSettingsService = {
  findPromotionSettings: () => MHTTPCL.post(SETTINGS_URL, {
    section: 'promosettings',
    action:'promotion_settings_tab',
    output: JSON_STRING,
  }),

  insertResultType:(result_type)=>MHTTPCL.post(SETTINGS_URL,{
    section: 'promosettings',
    action: 'add_result_type',
    result_type: result_type
  }),

  updateResultType:(result_type_id,result_type)=>MHTTPCL.post(SETTINGS_URL,{
    kVal: result_type_id,
    name: 'result_type',
    value:result_type,
    table: 'p_result_types',
    modified: '{last_modified}',
    DOMid:'result_type_',
    modify_type: '',
    json_op: '',
    json_key:''
  }),
  deleteResultType:(result_type_id)=>MHTTPCL.post(SETTINGS_URL,{
    section: 'promosettings',
    action: 'delete_result_type',
    result_type_id: result_type_id
  }),

  insertCustomField:(external_table,field_label)=>MHTTPCL.post(SETTINGS_URL,{
    section: 'promosettings',
    action: 'add_custom_field',
    field_label: field_label,
    external_table:external_table
  }),
  updateCustomField:(field_id,field_label)=>MHTTPCL.post(MODIFICATION_URL,{
    kVal: field_id,
    name: 'field_label',
    value:field_label,
    table: 'custom_fields',
    modified: '{last_modified}',
    DOMid:'field_label_',
    modify_type: '',
    json_op: '',
    json_key:''
  }),

  deleteCustomField:(result_type_id)=>MHTTPCL.post(SETTINGS_URL,{
    section: 'promosettings',
    action: 'delete_custom_field',
    custom_field_id: result_type_id
  }),

  getCategoryDetails:(category_id)=>MHTTPCL.post(SETTINGS_URL,{
    section: 'promosettings',
    action:'sub_categories',
    category_id: category_id,
  }),

  insertCategory:(category_id,category_name,sub_category_names,task)=>MHTTPCL.post(SETTINGS_URL,{
    section:'promosettings',
    action:'add_edit_category',
    category_id:category_id,
    category_name:category_name,
    sub_category_names:sub_category_names,
    task:task
  }),
  deleteCategory:(category_id)=>MHTTPCL.post(SETTINGS_URL,{
    section:'promosettings',
    action:'delete_category',
    category_id:category_id
  }),

  updateCategories:(category_id,cat_value)=>MHTTPCL.post(MODIFICATION_URL,{
    kVal: category_id,
    name: 'category_name',
    value:cat_value,
    table: 'p_categories',
    modified: 'last_modified',
  
    modify_type: '',
    json_op: '',
    json_key:''
  }),

  updateSubCategories:(category_id,cat_value)=>MHTTPCL.post(MODIFICATION_URL,{
    kVal: category_id,
    name: 'category_name',
    value:cat_value,
    table: 'p_categories',
    modified: '0000-00-00+00:00:00',
    
    modify_type: '',
    json_op: '',
    json_key:''
  }),

  insertMedia:(category_id,category_name,sub_category_names,task)=>MHTTPCL.post(SETTINGS_URL,{
    section:'promosettings',
    action:'add_edit_media_type',
    media_type_id:category_id,
    media_type_name:category_name,
    field_labels:sub_category_names,
    task:task
  }),

  updateSubLabel:(category_id,cat_value)=>MHTTPCL.post(MODIFICATION_URL,{
    kVal: category_id,
    name: 'field_label',
    value:cat_value,
    table: 'custom_fields',
    modified: '0000-00-00+00:00:00',
    
    modify_type: '',
    json_op: '',
    json_key:''
  }),


  deleteSubLabel:(category_id)=>MHTTPCL.post(SETTINGS_URL,{
    section:'promosettings',
    action:'delete_custom_field',
    custom_field_id:category_id
  }),

  getMediaDetails:(category_id)=>MHTTPCL.post(SETTINGS_URL,{
    section: 'promosettings',
    action:'media_custom_fields',
    media_type_id: category_id,
  }),


  updateMedia:(category_id,cat_value)=>MHTTPCL.post(MODIFICATION_URL,{
    kVal: category_id,
    name: 'media_type_name',
    value:cat_value,
    table: 'p_media_types',
    modified: 'last_modified',
  
    modify_type: '',
    json_op: '',
    json_key:''
  }),
  deleteMedia:(category_id)=>MHTTPCL.post(SETTINGS_URL,{
    section:'promosettings',
    action:'delete_media_type',
    media_type_id:category_id
  }),
}